import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Modal, Select, Button, Group, SegmentedControl, Text, Box } from '@mantine/core';
import { IconCheck, IconX } from '@tabler/icons-react';
import TestsApi from "../../api/TestsApi";
import { notifications } from '@mantine/notifications';
import { HelpTip } from "../../components/GeneralComponent/GeneralComponent";

export function AttributionWindow({ pageId, isAttributionWindowModalOpen, onAttributionWindowClose, setMarksalestime, TestOptimizeReport }:any) {
  const navigate = useNavigate();
  const [attributionWindow, setAttributionWindow] = useState('true_journey');
  const [lookbackDays, setLookbackDays] = useState('30');


  useEffect(() => {
    if (isAttributionWindowModalOpen) {
      setAttributionWindow('true_journey');
      setLookbackDays('30');
      if (!pageId) {
        navigate('/review-tests');
        return;
      }
      TestsApi.getattributionwindow({
        page_id:pageId
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if (data.status === 1) {
          if (data.data.attribute_window_type === 'lookback') {
            setAttributionWindow('lookback');
          }
          if (data.data.lookback_days > 0) {
            setLookbackDays(String(data.data.lookback_days));
          }
        } else {
          notifications.show({
            color: 'red',
            icon: <IconX size="1.1rem" />,
            title: 'Error',
            message: data.message,
          });
          onAttributionWindowClose();
        }
      })
      .catch(error => {
        console.error("API Error:", error);
      });
    }
  }, [isAttributionWindowModalOpen, pageId]);

  const handleSaveAttributionWindow = (e) => {
    e.preventDefault();
    TestsApi.saveattributionwindow({
      page_id:pageId,
      attribute_window_type:attributionWindow,
      lookback_days:(attributionWindow === 'lookback') ? parseInt(lookbackDays, 10) : 0
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if(data.status === 1){
        setMarksalestime(data.data.updated_time);
        TestOptimizeReport();
        notifications.show({
          color: 'green',
          icon: <IconCheck size="1.1rem" />,
          title: 'Success',
          message: data.message,
        });
        onAttributionWindowClose();
      } else {
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: data.message,
        });
        onAttributionWindowClose();
      }
    })
    .catch(error => {
      console.error("API Error:", error);
    });
  }


  return (
    <>
      <Modal.Root opened={isAttributionWindowModalOpen} onClose={onAttributionWindowClose} trapFocus={false}>
        <Modal.Overlay />
        <Modal.Content>
          <Modal.Header>
            <Modal.Title>ATTRIBUTION WINDOW <HelpTip helpId={384} /></Modal.Title>
            <Modal.CloseButton />
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={handleSaveAttributionWindow}>
              <SegmentedControl
                fullWidth
                color="teal"
                size="sm"
                value={attributionWindow}
                onChange={(v:any) => setAttributionWindow(v)}
                data={[
                  { label: 'True Customer Journey', value: 'true_journey' },
                  { label: 'Lookback Window', value: 'lookback' },
                ]}
              />

              {attributionWindow === 'true_journey' ? (
                <Text size="xs" color="dimmed" mt={10}>
                  Credit the visit that led to the sale, however long ago it happened.
                </Text>
              ) : (
                <Box mt={10}>
                  <Select
                    label="Lookback Window"
                    value={lookbackDays}
                    onChange={(v) => v && setLookbackDays(v)}
                    data={[
                      { value: '7', label: '7 days' },
                      { value: '30', label: '30 days' },
                      { value: '60', label: '60 days' },
                      { value: '90', label: '90 days' },
                      { value: '365', label: '365 days' },
                    ]}
                    size="sm"
                    maxDropdownHeight={200}
                    dropdownPosition="bottom"
                    withinPortal
                  />
                  <Text size="xs" color="dimmed" mt={8}>
                    Only credit a visit if the sale happened within {lookbackDays} days of it.
                  </Text>
                </Box>
              )}

              <Group position="right" mt={16}>
                <Button type="submit" size="sm" w={80}>
                  Save
                </Button>
              </Group>
            </form>
          </Modal.Body>
        </Modal.Content>
      </Modal.Root>
    </>
  );
}
